<template>
  <el-dialog
    title="成品发往钻井"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :rules="rules"
      ref="form"
      size="small"
      label-width="80px"
      :model="model"
    >
      <!-- <el-form-item label="图片">
        <el-upload
          class="upload-small"
          multiple
          :action="actionUrl"
          :headers="uploadHeader"
          :on-error="handleUploadError"
          :on-remove="handleOnRemove"
          :on-success="handleOnSuccess"
          list-type="picture-card"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item> -->

      <el-form-item label="接收钻井" prop="receive_well_id" v-if="visible">
        <DrillWellSelect v-model="model.receive_well_id"></DrillWellSelect>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { productUpdateDrillWell } from '@/service/getData'
import { urlPerfix } from '@/config/env'
import store from '@/store/index'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      actionUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      submiting: false,
      rules: {
        receive_well_id: [
          { required: true, message: '请选择接收钻井', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res = await productUpdateDrillWell(this.model)
          if (res.code == 0) {
            this.$emit('updated', res.data)
            this.visible = false
          }
          this.submiting = false
        } else {
          this.submiting = false
          return false
        }
      })
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    handleOnRemove(file) {
      let index = this.model.imgs.indexOf(file.response.data)
      this.model.imgs.splice(index, 1)
    },
    handleOnSuccess(res, file) {
      this.model.imgs.push(res.data)
    },
  },
}
</script>